import React from 'react';
import { Link } from 'react-router-dom';
import nursery from "../../assests/nursery.jpg";
import standup from "../../assests/standup.jpg";
import vandemataram from "../../assests/vande_mataram.jpg";

function EducatingChildren() {
  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        background: "#fff",
        color: "#333",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "0 1.5rem 3rem",
        }}
      >
        {/* Back */}
        <Link
          to="/"
          style={{
            color: "#c47a1e",
            textDecoration: "none",
            display: "inline-block",
            fontSize: "13px",
            marginTop: "1.5rem",
          }}
        >
          ← Back to Home
        </Link>

        {/* Heading */}
        <h1
          style={{
            fontFamily: "'Dancing Script','Brush Script MT',cursive",
            color: "#ef7d32",
            fontSize: "2.8rem",
            marginBottom: ".3rem",
          }}
        >
          Educating Children as Future Leaders
        </h1>

        {/* Orange Dots */}
        <div
          style={{
            display: "flex",
            gap: 4,
            marginBottom: "2rem",
          }}
        >
          {[...Array(12)].map((_, i) => (
            <span
              key={i}
              style={{
                width: 5,
                height: 5,
                borderRadius: "50%",
                background: "#ef7d32",
              }}
            />
          ))}
        </div>

        {/* Intro */}
        <p
          style={{
            fontSize: "14px",
            lineHeight: "1.9",
            marginBottom: "2rem",
          }}
        >
          The campus houses the Nava Jeevan Institution that includes the
          Nava Jeevan Public School and the Nava Jeevan Christian Jr. College.
        </p>

        {/* Main Content */}
        <div
          style={{
            display: "flex",
            gap: "2rem",
            flexWrap: "wrap",
            alignItems: "flex-start",
          }}
        >
          {/* Left Image */}
          <img
            src={nursery}
            alt="Nava Jeevan School"
            style={{
              width: "470px",
              maxWidth: "100%",
              height: "320px",
              objectFit: "cover",
            }}
          />

          {/* Right Text */}
          <div
            style={{
              flex: 1,
              minWidth: "300px",
              fontSize: "14px",
              lineHeight: "1.9",
            }}
          >
            <p>
              Our Australian ambassadors, Dr Gladwyn and Helen Turner and
              their team, assisted in the school project in 1984. The school
              offers quality education to children in grades 1 to 10. In order
              to improve the training opportunities, the junior college was
              established in 2001 for grades 11 and 12. Many of the graduates
              of this institution are enrolled in Engineering and Medical
              Colleges.
            </p>

            <p>
              Today, there are 650 students enrolled from all over Andhra
              Pradesh and other states, along with 34 certified teachers. The
              Junior College welcomes 100 registered students.
            </p>

            <p>
              At Nava Jeevan, we prepare our students for a world full of
              conflict, opportunity, and social, interpersonal, and global
              challenges.
            </p>

            <p>
              Because students are from all over India, many languages are
              spoken on campus, including Telugu. Students are taught in
              English.
            </p>
          </div>
        </div>

        {/* Bottom Images */}
        <div
          style={{
            display: "flex",
            gap: "2rem",
            marginTop: "2rem",
            flexWrap: "wrap",
          }}
        >
          <img
            src={standup}
            alt="Students"
            style={{
              flex: 1,
              minWidth: "320px",
              height: "270px",
              objectFit: "cover",
            }}
          />

          <img
            src={vandemataram}
            alt="School Students"
            style={{
              flex: 1,
              minWidth: "320px",
              height: "270px",
              objectFit: "cover",
            }}
          />
        </div>
      </div>

      {/* Support Section */}
      <div
        style={{
          background: "#2d8b57",
          color: "#fff",
          textAlign: "center",
          padding: "3rem 1rem",
          marginTop: "3rem",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: "36px",
            fontWeight: "bold",
          }}
        >
          Support Our Ministry
        </h2>

        <p
          style={{
            margin: "15px 0 30px",
            fontSize: "15px",
          }}
        >
          Help support and educate children as future leaders.
        </p>

        {/* Sponsor Children PayPal Donation Button */}
        <a
          href="https://www.paypal.com/donate/?hosted_button_id=SARBARXK6BRK6"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            display: "inline-block",
          }}
        >
          <button
            type="button"
            style={{
              background: "#fff",
              color: "#2d8b57",
              border: "2px solid #fff",
              padding: "12px 35px",
              fontWeight: "bold",
              cursor: "pointer",
              fontSize: "15px",
            }}
          >
            GIVE
          </button>
        </a>
      </div>
    </div>
  );
}

export default EducatingChildren;
